"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
var _react = require("react");
var _functions = require("../utils/functions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const _useCreateFiltersByParam = props => {
  const {
    types = [],
    /* thingCity, thingZIPCode, warning*/
    data = [],
    activeFilters: filter = {}
  } = props;
  const [hasWarning, setHasWarning] = (0, _react.useState)(false);
  const [cityList, setCityList] = (0, _react.useState)();
  const [zipList, setZipList] = (0, _react.useState)();
  const filterProp = (0, _react.useCallback)(function () {
    let byData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return byData.find(r => filter[r]) ? data.filter(p => byData.find(r => (0, _functions.getTextByLanguage)(p[r]) === filter[r])) : data;
  }, [filter, data]);
  const generateList = (0, _react.useCallback)(function (name) {
    let byData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return filterProp(byData).reduce((acc, p) => {
      if (acc.find(a => (0, _functions.getTextByLanguage)(a[name]) === (0, _functions.getTextByLanguage)(p[name]))) {
        const replaceIndex = acc.findIndex(a => (0, _functions.getTextByLanguage)(a[name]) === (0, _functions.getTextByLanguage)(p[name]));
        return [...acc.map((a, i) => replaceIndex !== i ? a : _objectSpread(_objectSpread({}, a), {}, {
          count: a.count + 1
        }))];
      } else return [...acc, {
        [name]: p[name],
        count: 1
      }];
    }, []);
  }, [filterProp]);
  const setWarning = (0, _react.useCallback)(() => {
    setHasWarning(data.find(p => {
      var _p$devices;
      return (_p$devices = p.devices) === null || _p$devices === void 0 ? void 0 : _p$devices.find(s => !s.status);
    }) !== null);
  }, [data]);
  const setCity = (0, _react.useCallback)(() => {
    setCityList(generateList('thingCity', ['thingZIPCode']));
  }, [setCityList, generateList]);
  const setZip = (0, _react.useCallback)(() => {
    setZipList(generateList('thingZIPCode', ['thingCity']));
  }, [setZipList, generateList]);
  const filtersControl = {
    warning: setWarning,
    thingCity: setCity,
    thingZIPCode: setZip
  };
  const filterResults = {
    warning: hasWarning,
    thingCity: cityList,
    thingZIPCode: zipList
  };
  (0, _react.useEffect)(() => {
    if (data && types) {
      types.forEach(type => filtersControl[type]());
    }
  }, [data, filter]);
  return types.reduce((acc, type) => _objectSpread(_objectSpread({}, acc), {}, {
    [type]: filterResults[type]
  }), {});
};
var _default = exports.default = _useCreateFiltersByParam;